// Mouse-following pan effect for multicolumn images
document.addEventListener('DOMContentLoaded', function() {
  const multicolumnImages = document.querySelectorAll('.multicolumn img');
  
  multicolumnImages.forEach(img => {
    const wrapper = img.closest('.multicolumn-card__image-wrapper');
    
    if (wrapper) {
      wrapper.addEventListener('mousemove', function(e) {
        const rect = wrapper.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        
        const percentX = (x - centerX) / centerX;
        const percentY = (y - centerY) / centerY;
        
        const moveX = percentX * 15;
        const moveY = percentY * 15;
        
        img.style.transform = `scale(1.15) translate(${moveX}px, ${moveY}px)`;
      });
      
      wrapper.addEventListener('mouseleave', function() {
        img.style.transform = 'scale(1) translate(0, 0)';
      });
    }
  });
});



// Close mobile menu when any link inside the drawer is clicked
document.addEventListener('DOMContentLoaded', function () {
  var menuDrawer = document.getElementById('menu-drawer');
  if (menuDrawer) {
    menuDrawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        var closeBtn = document.querySelector('.menu-drawer__close-menu-btn');
        if (closeBtn) closeBtn.click();
      });
    });
  }
});


